import { hasRole, useUser } from "@/auth/useUser";
import { Role } from "@/types";

export default function useUserHasRoles(roles: string[]) {
  const { user } = useUser();

  return hasRole(user, roles as Role[]);
}
